import { Component, Input } from '@angular/core'
import { ModalController } from '@ionic/angular'

@Component({
  selector: 'efp-modal-form',
  templateUrl: './modal-form.component.html',
  styleUrls: ['./modal-form.component.scss'],
})
export class ModalFormComponent {
  @Input() dismissable = true

  constructor(public readonly modalCtrl: ModalController) {}

  public async closeModal(): Promise<void> {
    if (this.dismissable) {
      await this.modalCtrl.dismiss()
    }
  }
}
